import { createEffect, onCleanup, onMount } from 'solid-js'
import { useService } from 'solid-services'
import { Box } from 'styled-system/jsx'
import { useSingle } from '../state'

export default function () {
	const { setupResource } = useService(useSingle)()
	let containerRef: HTMLDivElement | undefined

	const loadWidget = () => {
		if (!containerRef) return

		// Remove existing script if it exists (prevents duplicate loading)
		const existingScript = document.querySelector('#tradingview-script')
		if (existingScript) existingScript.remove()

		// Create a new script element
		const script = document.createElement('script')
		script.id = 'tradingview-script'
		script.src =
			'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js'
		script.type = 'text/javascript'
		script.async = true

		// Widget configuration
		script.innerHTML = JSON.stringify({
			autosize: true,
			symbol: `${setupResource()?.exchange}:${setupResource()?.symbol}`,
			interval: 'D',
			timezone: 'Etc/UTC',
			theme: 'dark',
			style: '1',
			locale: 'en',
			hide_top_toolbar: true,
			hide_legend: true,
			allow_symbol_change: false,
			save_image: false,
			support_host: 'https://www.tradingview.com',
		})

		// Append script inside the container
		containerRef?.appendChild(script)
	}

	onMount(() => loadWidget())

	// Re-load widget when the symbol changes
	createEffect(() => {
		loadWidget()
	})

	// Cleanup to prevent memory leaks
	onCleanup(() => {
		const existingScript = document.querySelector('#tradingview-script')
		if (existingScript) existingScript.remove()
	})

	return (
		<Box height="calc(100vh - 142px)">
			<div
				class="tradingview-widget-container"
				style="height:100%; width:100%"
				ref={containerRef}
			>
				<div
					class="tradingview-widget-container__widget"
					style="height:calc(100% - 32px);width:100%"
				></div>
				<div class="tradingview-widget-copyright">
					<a
						href="https://www.tradingview.com/"
						rel="noreferrer noopener nofollow"
						target="_blank"
					>
						<span class="blue-text">Track all markets on TradingView</span>
					</a>
				</div>
			</div>
		</Box>
	)
}
